<!--<div fxLayout="column">
  <div class="button-container" fxLayout="row" fxLayoutAlign="start center">
    <button mat-button class="orbitax-flat-button" (click)="Add()"
            particleAnalytics
            analyticsCategory="entity-transactions-content"
            analyticsAction="add-section"
    >Add Record
    </button>

    <div class="toolbar-separator"></div>
  </div>
  <div class="keno-grid-container" style="position: relative">
    <particle-virtual-grid [sourceKey]="sourceType"
                           [invalidateSubject]="invalidateSubject"
    >
    </particle-virtual-grid>
  </div>
</div>-->

<div class="toolbar-fixed-layout">

  <!--<div class="toolbar second-level-toolbar" fxLayoutAlign="space-between center">
    <div *ngIf="userApp === 'DAC6'" fxLayout="column" fxLayoutAlign="center start" class="grid-toolbar-buttons-group-container">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group" fxLayout="row" fxLayoutAlign="start center">
        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">
          <button mat-button class="orbitax-flat-button" (click)="Add()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Add Record
          </button>
        </div>
        </div>
    </div>

  </div>-->

  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div *ngIf="userApp === 'DAC6'"
         class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">

      <div class="flex flex-row justify-start items-center">
        <button mat-button class="link-button" (click)="Add()"
                particleAnalytics
                analyticsCategory="entity-transactions-content"
                analyticsAction="add-section"
        >Add Record
        </button>
      </div>
    </div>

  </div>

  <mat-sidenav-container style="background-color: white;">
    <div class="content pos-relative flex flex-col full-grow-no-shrink-no-basis">
      <div class="keno-grid-container">
        <particle-virtual-grid [sourceKey]="sourceType"
                               [invalidateSubject]="invalidateSubject"
                               (valueChanged)="onGridCellValueChange($event)"
        >
        </particle-virtual-grid>
      </div>
    </div>

  </mat-sidenav-container>

</div>
